import { useFetch } from "@/hooks/useFetch";

export function useAiSettings(deps = []) {
  const { data, refetch } = useFetch("/ai/settings", deps);
  const on = (feature) => !!data && data.enabled && data[feature] !== false;
  return { settings: data, refetch, on, loaded: !!data };
}
